<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				@row-dblclick='rowClick'
				:height="tableHeight"
				ref="table"
				@sort-change='sortChangeHandle'
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
			>
				<el-table-column
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					prop="staff"
					label="员工姓名"
					align="center">
					<template slot-scope="scope">
						<el-tooltip effect="dark" :content="scope.row.staff" placement="top-start">
							<div class="over-hidden">{{scope.row.staff}}</div>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column
					prop="commissionrules"
					label="返佣方式"
					align="center"
					width="200">
					<template slot-scope="scope">
						混合：{{scope.row.commissiontype === 1 ? `百分比（${scope.row.commissionvalue}%）` : `固定金额（￥${$fxUtils.toFixedSHW(scope.row.commissionvalue, 2)}）`}}
					</template>
				</el-table-column>
				<el-table-column
					prop="cashoutcode"
					label="提现编号"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.cashoutcode}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="cashoutmoney"
					label="申请提现金额"
					sortable="custom"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.cashoutmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="createdate"
					label="申请时间"
					sortable="custom"
					align="center">
				</el-table-column>
				<el-table-column
					prop="reviewdate"
					label="审核时间"
					align="center">
					<template slot-scope="scope">
						<div>{{scope.row.reviewdate ? scope.row.reviewdate : '——'}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="cashoutdate"
					label="到账时间"
					sortable="custom"
					align="center"
					width="220">
					<template slot-scope="scope">
						<div>{{scope.row.cashoutdate ? `${scope.row.cashoutdate}（T+${scope.row.cycleday}）` : '——'}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="cashOutStatusName"
					label="状态"
					align="center">
				</el-table-column>
				<el-table-column label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" v-if="AuthorityList['11_0004_0001_00'] && AuthorityList['11_0004_0002_00'] && AuthorityList['11_0004_0003_00']" @click="getDetail(scope.row, )">明细</el-button>
						<el-button v-if="scope.row.cashOutStatusName === '待审核' && AuthorityList['11_0004_0003_00']" type='text' size="mini" @click="multiSave(scope.row, 2)">同意</el-button>
						<el-button v-if="scope.row.cashOutStatusName === '待审核' && AuthorityList['11_0004_0003_00']" type='text' size="mini" @click="multiSave(scope.row, 0)">拒绝</el-button>
						<el-button v-if="scope.row.cashOutStatusName === '待打款' && AuthorityList['11_0004_0003_00']" type='text' size="mini" @click="multiSave(scope.row, 3)">标记打款</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		}
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'cashoutid'
			})
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		initIschoose () {
			this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
		},
		clear () {
			this.tableSelectUtils.clear()
		},
		rowClick (row, column, event) {
			if (this.AuthorityList['11_0004_0001_00'] || this.AuthorityList['11_0004_0002_00'] || this.AuthorityList['11_0004_0003_00']) {
				this.getDetail(row)
			}
		},
		sortChangeHandle (data) {
			if (data.order === null) {
				this.$emit('sortSearch', { orderKey: '', orderBy: '' })
			} else {
				let orderBy = data.order === 'descending' ? 'desc' : 'asc'
				this.$emit('sortSearch', { orderKey: data.prop, orderBy: orderBy })
			}
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			let value = this.tableSelectUtils.getSelectRows()
			this.$emit('selectData', value)
			let ids = value.map(item => {
				return item.cashoutid
			})
			this.$emit('selectIds', ids)
		},
		getDetail (value) {
			window.sessionStorage.setItem('withdrawalReviewId', value.cashoutid)
			this.$router.push(`/main/withdrawalReviewDetail`)
		},
		multiSave (row, num) {
			let params = {
				cashOutStatus: num,
				cashOutIds: row.cashoutid
			}
			let text = `员工名称【${row.staff}】提现编号【${row.cashoutcode}】提现金额【￥${row.cashoutmoney}】审核【${num === 2 ? '同意' : '拒绝'}】`
			let changeData = {
				pre: { cashOutData: {} },
				cur: { cashOutData: { text: text } }
			}
			const logger = this.$fxLogger.createInfo('results.withdrawalReview.update', changeData)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/cashout/cashoutstatus`,
				data: params,
				logger
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$emit('modifySuc')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
	}
	.over-hidden{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
}
</style>
